export const NUMBER = '1300360520';
export const TEXT = '1300 360 520';
export const SUPPORT_HOURS =
  '8:00am - 8:00pm AEDT/AEST Monday to Friday, 8:30am - 5:30pm AEDT/AEST, Saturday and Sunday';
export const LIVE_CHAT_HOURS = '8:30am - 5:30pm AEDT/AEST, Monday to Friday';
